import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import {IconButton} from '@carbon/react';
import { Edit, TrashCan } from '@carbon/react/icons';


// DATOS MUESTRA ----------
const rows = [{
    id: '1',
    nombre: 'Juan Carlos López Moreno',
    perfil: 'Administrador',
    correo: 'jcmoreno@humansite.com.mx',
    acciones: <> <IconButton kind="ghost" label="Editar" > <Edit /> </IconButton>,
    <IconButton kind="ghost" label="Eliminar" > <TrashCan /> </IconButton></>
   
  }
];
//------------------------

const headers = [
    { name: <div>ID</div>, selector: rows=>rows['id'], width: '50px', wrap: true  },
    { name: <div>NOMBRE</div>, selector: rows=>rows['nombre'], width: '230px', wrap: true  },
    { name: <div>PERFIL</div>, selector: rows=>rows['perfil'], width: '250px', wrap: true  },
    { name: <div>CORREO</div>, selector: rows=>rows['correo'], width: '300px', wrap: true  },
    { name: <div>ACCIONES</div>, selector: rows=>rows['acciones'], wrap: true  },
];

const UsuariosTable = ({ /*rows*/ }) => {
    const [filteredRows, setFilteredRows] = useState(rows);

    useEffect(() => {
        setFilteredRows(rows);
    }, [rows]);

    const handleSearch = (value) => {
        const filteredData = rows.filter((row) => {
            return Object.values(row).some((val) =>
                String(val).toLowerCase().includes(value.toLowerCase())
            );
        });

        setFilteredRows(filteredData);
    };

    return (
        <DataTable
            title=""
            columns={headers}
            data={filteredRows}
            pagination
            paginationPerPage={5}
            paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
            highlightOnHover
            subHeader
            subHeaderComponent={
                <input
                    type="text"
                    className='busqueda'
                    placeholder="BÚSQUEDA"
                    onChange={(e) => handleSearch(e.target.value)}
                />
            }
            noDataComponent="No hay datos disponibles"
            paginationComponentOptions={{
                rowsPerPageText: 'Filas por página:',
                rangeSeparatorText: 'de',
                noRowsPerPageText: 'Sin filas por página',
            }}
        />
    );
};

export default UsuariosTable;
